import React from "react";
import {FormControl, InputLabel, MenuItem, Select, withStyles} from "@material-ui/core";


const styles = {
  filterField: {
    minWidth: 150,
    width: 150,
    maxWidth: 150,
  },
  filterBox: {
    flex: 1,
  },
};
function ListFilter({label, filterList, selectedItems, handleSelect, classes}) {

  return (
      <div className={classes.filterBox}>
        <FormControl className={classes.filterField}>
          <InputLabel shrink>
            {label} ({filterList.length})
          </InputLabel>
          <Select
            multiple
            value={selectedItems}
            onChange={handleSelect}
          >
            {filterList.map(item => <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>)}
          </Select>
        </FormControl>
      </div>
  );
}

export default withStyles(styles)(ListFilter);